import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefHistoryOBGyHistoryOutcomeOfSurgeryDetailByID = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryOutcomeOfSurgery/GetDetail?` + params, null);

export const GetRefHistoryOBGyHistoryOutcomeOfSurgeryList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryOutcomeOfSurgery/GetList?` + params, null);

export const CreateRefHistoryOBGyHistoryOutcomeOfSurgery = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryOutcomeOfSurgery/Create`, data);

export const UpdateRefHistoryOBGyHistoryOutcomeOfSurgery = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryOutcomeOfSurgery/Update`, data);

export const DeleteRefHistoryOBGyHistoryOutcomeOfSurgery = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryOBGyHistoryOutcomeOfSurgery/Delete`, data);